<section class="companion-section">
  <h3 class="companion-section__title">Companion setup</h3>
  <div class="companion-count-grid">
    <mat-form-field class="w-full" appearance="outline">
      <mat-label>Number of Companions</mat-label>
      <input
        type="number"
        step="1"
        min="1"
        max="3"
        matInput
        [formControl]="numberOfCompanions"
      />
      <mat-error *ngIf="ValidationHelperService.isInvalid(numberOfCompanions)">
        {{ ValidationHelperService.getErrorMessage(numberOfCompanions) }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="w-full" appearance="outline">
      <mat-label>Number of Sensors</mat-label>
      <input
        type="number"
        step="1"
        min="1"
        max="5"
        matInput
        [formControl]="numberOfSensors"
      />
      <mat-error *ngIf="ValidationHelperService.isInvalid(numberOfSensors)">
        {{ ValidationHelperService.getErrorMessage(numberOfSensors) }}
      </mat-error>
    </mat-form-field>

    <div
      class="companion-validation-callout"
      role="alert"
      *ngIf="hasCompanionConfigurationError()"
    >
      <i class="material-icons companion-validation-callout__icon">
        warning_amber
      </i>
      <div>
        <div class="companion-validation-callout__title">
          {{ getCompanionConfigurationErrorTitle() }}
        </div>
        <div class="companion-validation-callout__message">
          {{ getCompanionConfigurationErrorMessage() }}
        </div>
      </div>
    </div>
  </div>
</section>

<section class="companion-section">
  <h3 class="companion-section__title">Modes</h3>
  <mat-tab-group
    class="custom-tab-group custom-tab-group-large"
    [selectedIndex]="companionMode.value"
    (selectedTabChange)="onTabChange($event)"
  >
    <mat-tab
      label="Simultaneous"
      [disabled]="
        action === EAction.Edit &&
        companionMode.value !== ECompanionMode.Simultaneous
      "
    >
      <ng-template matTabContent>
        <app-companion-simultaneous-form
          [_formGroup]="_formGroup"
        ></app-companion-simultaneous-form>
      </ng-template>
    </mat-tab>
    <mat-tab
      label="React"
      [disabled]="
        action === EAction.Edit && companionMode.value !== ECompanionMode.React
      "
    >
      <ng-template matTabContent>
        <app-companion-react-form
          [_formGroup]="_formGroup"
        ></app-companion-react-form>
      </ng-template>
    </mat-tab>
    <mat-tab
      label="Agility"
      [disabled]="
        action === EAction.Edit &&
        companionMode.value !== ECompanionMode.Agility
      "
    >
      <ng-template matTabContent>
        <app-companion-agility-form
          [_formGroup]="_formGroup"
        ></app-companion-agility-form>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</section>
